<wr-new-data-table headerText="Prüfpunktübersicht"
                   [infoBanner]="catalogBanner()"
                   localStorageIdentifier="checkpoint-overview"
                   [loadItemsFunction]="loadCheckpoints"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToCheckpoint($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="isAdmin()"
                   [deprecatedRows]="true">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="checkpointGroup">Prüfpunktgruppe</label>
          <wr-checkpoint-group-select id="checkpointGroup"
                                      formControlName="checkpointGroupId"
                                      [tenantId]="tenantId()"
                                      [showEmptyOption]="true"></wr-checkpoint-group-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="deprecated">Prüfpunkt Status</label>
          <wr-deprecated-select id="deprecated" formControlName="deprecated"></wr-deprecated-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-checkpoint
    key="fullNumber"
    [exportValue]="exportCheckpointNumber"
    display="Nummer">
    @if (checkpoint.number) {
      <div>{{ getCheckpointNumber(checkpoint) }}</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-checkpoint
    key="groupName"
    exportKey="checkpointGroupName"
    display="Gruppe">
    @if (checkpoint) {
      <div>{{ getCheckpointGroupName(checkpoint) }}</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-checkpoint
    key="name"
    display="Name">
    @if (checkpoint.name) {
      <div>{{ checkpoint.name }}</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-checkpoint
    key="weight"
    display="Gewicht">
    @if (checkpoint.weight) {
      <div><wr-checkpoint-weight [weight]="checkpoint.weight"></wr-checkpoint-weight></div>
    }
  </ng-template>
</wr-new-data-table>
